import React from 'react';
import Popover from 'components/pure/utils/Popover';
import InputField from 'components/pure/utils/form/InputField';
import './SearchAndResultsStyles.styl';
import classnames from 'classnames';

export default class SearchAndResults extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  showSearchResults(searchTerm, hideResults) {
    return searchTerm && searchTerm.length >= 3 && !hideResults;
  }

  emptyResults(entities) {
    return !entities || entities.size === 0;
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  /**
   * Event handler for mouse click.  Fires parent event if the click is outside the search results box
   */
  handleClickOutside(event) {
    if (
      this.searchResultsNode &&
      !this.searchResultsNode.contains(event.target) &&
      this.props.onClickOutside
    ) {
      this.props.onClickOutside();
    }
  }

  renderLoadingOrSearching(entities, searchLoading) {
    if (this.emptyResults(entities) && !searchLoading) {
      return <div className="empty-results">No Results Found</div>;
    } else if (searchLoading) {
      return <div className="searching">Searching...</div>;
    }
  }

  render() {
    const {
      searchTerm,
      placeholder,
      entities,
      hideResults,
      searchLoading,
      className,
      searchDisabled,
      autoFocus,
    } = this.props;

    return (
      <div className={classnames('crm-search', className)}>
        <div className="header">
          <InputField
            autoFocus={autoFocus}
            inputRef={c => (this.searchAnchor = c)}
            value={searchTerm || ''}
            onChange={this.props.searchTermChanged}
            placeholder={placeholder}
            tabIndex={this.props.tabIndex}
            disabled={searchDisabled ? 'disabled' : ''}
          />
        </div>
        {this.showSearchResults(searchTerm, hideResults) && (
          <Popover
            open={true}
            onRequestClose={reason => this.props.onClickOutside(reason)}
            className={classnames('crm-search-results', className)}
            canAutoPosition={false}
            useLayerForClickAway={false}
            anchorEl={this.searchAnchor}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}>
            <div className="search-results" ref={node => (this.searchResultsNode = node)}>
              {this.renderLoadingOrSearching(entities, searchLoading)}
              {entities && (
                <ul>
                  {entities.map(entity => (
                    <li key={entity.id} onClick={() => this.props.entityClick(entity)}>
                      {entity.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Popover>
        )}
      </div>
    );
  }
}
